export default {
    url: '/auditlog',
    template: '<manage-logs-auditlog></manage-logs-auditlog>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/logs/auditlog/index.js